import { useDisplayPreferences, type AppTextCase } from '../contexts/DisplayPreferencesContext';

export default function TextCasePreference() {
  const { appTextCase, setAppTextCase } = useDisplayPreferences();
  return (
    <div className="space-y-2">
      <label htmlFor="app-text-case" className="block text-sm font-medium text-heading">
        Text appearance
      </label>
      <select
        id="app-text-case"
        value={appTextCase}
        onChange={(event) => setAppTextCase(event.target.value as AppTextCase)}
        aria-describedby="app-text-case-help"
        className="w-full rounded-md border border-theme-border-primary bg-theme-bg-primary p-2 text-sm text-heading"
      >
        <option value="original">Original</option>
        <option value="uppercase">ALL CAPS</option>
        <option value="title">Title Case</option>
      </select>
      <p id="app-text-case-help" className="text-xs text-muted">
        Changes text appearance throughout 360, including grids and fields.
        Saved values and exports keep their original text. Title Case capitalizes
        word initials and preserves existing capitals.
      </p>
    </div>
  );
}
